module.exports = __webpack_public_path__ + "static/media/photo217.81462e3c.jpg";